// Date-only values are business dates; timestamps are displayed in UK time.
export const chargeDateKey = (value) => {
  if (!value) return "";
  if (typeof value === "string" && /^\d{4}-\d{2}(-\d{2})?$/.test(value)) {
    const date = value.length === 7 ? `${value}-01` : value;
    const parsed = new Date(`${date}T00:00:00Z`);
    return Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date ? "" : date;
  }
  const date = value?.toDate?.() || (typeof value?.seconds === "number"
    ? new Date(value.seconds * 1000) : new Date(value));
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(date);
  const part = (type) => parts.find((item) => item.type === type).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
};

export const chargeMonthKey = (value) => chargeDateKey(value).slice(0, 7);

export const lastWorkingDayOfMonth = (month) => {
  const [year, monthNumber] = String(month || "").split("-").map(Number);
  if (!year || !monthNumber || monthNumber < 1 || monthNumber > 12) return "";
  const date = new Date(year, monthNumber, 0);
  while (date.getDay() === 0 || date.getDay() === 6) {
    date.setDate(date.getDate() - 1);
  }
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};

export const formatMonthKey = (value) => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})$/);
  if (!match) return String(value || "");
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1));
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 7) !== value) {
    return String(value || "");
  }
  return date.toLocaleDateString("en-GB", {
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
};

export const chargesForMonth = (records, month) => records.flatMap((record) => {
  const startMonth = chargeMonthKey(record.billingStartDate || record.date);
  const guidelineMonth = chargeMonthKey(record.fromDate);
  const endMonth = chargeMonthKey(record.chargeTo);
  if (!startMonth || month < startMonth || (guidelineMonth && month < guidelineMonth)) return [];
  if (endMonth && month > endMonth) return [];
  const index = (key) => Number(key.slice(0, 4)) * 12 + Number(key.slice(5, 7));
  const elapsed = index(month) - index(startMonth);
  let applies = elapsed === 0;
  if (record.recurrence === "monthly") applies = true;
  if (record.recurrence === "annual") applies = elapsed % 12 === 0;
  if (record.recurrence === "installment") applies = elapsed < (record.installments || 1);
  return applies ? [{ ...record, billingMonth: month, sourceDate: record.sourceDate ?? record.date }] : [];
});
